import { useEffect } from "react";
import LabelInput from "components/Base/LabelInput";
import CustomDropDown from "components/Base/CustomDropDown";
import LabelTextArea from "components/Base/LabelTextArea";
import { MINUTES, HOURS, SERVINGS } from "constants/add-recipe.constants";
import _ from 'lodash';
import useStyles from "./styles";
import { nextArrowIcon } from "assets/icons";

const Step1 = (props: any) => {
  const classes = useStyles();
  const {
    onNextClick,
    getValues,
    register,
    errors,
    onHandleCloseModal,
    recipeName,
    setRecipeName,
    recipeDesc,
    setRecipeDesc,
    prepHours,
    setPrepHours,
    prepMinutes,
    setPrepMinutes,
    cookHours,
    setCookHours,
    cookMinutes,
    setCookMinutes,
    servings,
    setServings,
    watch,
    isEdit,
    itemEdit,
    setEditRecipe,
    errorRecipeName,
    setErrorRecipeName,
    errorRecipeDesc,
    setErrorRecipeDesc,
    setItemEditState
    // urlVideoRecipe,
    // setUrlVideoRecipe,
  } = props;

  const handleValidate = () => {
    if (recipeName.trim() === '') {
      setErrorRecipeName(true)
    } else {
      setErrorRecipeName(false)
    }
    if (recipeDesc.trim() === '') {
      setErrorRecipeDesc(true)
    } else {
      setErrorRecipeDesc(false)
    }
  }

  const onChangeBlurNameRecipe = () => {
    const value = getValues('recipeName');
    setRecipeName(value);
    (value.trim() !== itemEdit?.name) && setEditRecipe(true);
    if(value.trim() !== '') return setErrorRecipeName(false)
    setErrorRecipeName(true)
  };

  const onChangeBlurRecipeDesc = () => {
    const value = getValues('recipeDesc');
    setRecipeDesc(value);
    (value.trim() !== itemEdit?.description) && setEditRecipe(true);
    if(value.trim() !== '') return setErrorRecipeDesc(false)
    setErrorRecipeDesc(true)
  };

  const onSelectPrepHours = (event: any) => {
    setPrepHours(event?.target?.value);
    setItemEditState({...itemEdit, prep_hours: event?.target?.value});
    (event?.target?.value !== itemEdit?.prep_hours) && setEditRecipe(true);
  };

  const onSelectPrepMinutes = (event: any) => {
    setPrepMinutes(event?.target?.value);
    setItemEditState({...itemEdit, prep_minutes: event?.target?.value});
    (event?.target?.value !== itemEdit?.prep_minutes) && setEditRecipe(true);
  };

  const onSelectCookHours = (event: any) => {
    setCookHours(event?.target?.value);
    setItemEditState({...itemEdit, cook_hours: event?.target?.value});
    (event?.target?.value !== itemEdit?.cook_hours) && setEditRecipe(true);
  };

  const onSelectCookMinutes = (event: any) => {
    setCookMinutes(event?.target?.value);
    setItemEditState({...itemEdit, cook_minutes: event?.target?.value});
    (event?.target?.value !== itemEdit?.cook_minutes) && setEditRecipe(true);
  };

  const onSelectServings = (event: any) => {
    setServings(event?.target?.value);
    setItemEditState({...itemEdit, servings: event?.target?.value});
    (event?.target?.value !== itemEdit?.servings) && setEditRecipe(true)
  };

  const onNextStep1 = () => {
    handleValidate();
    if(recipeName.trim() === '' || recipeDesc.trim() === '') return
    if (!errorRecipeName && !errorRecipeDesc) {
      onNextClick();
    }
    let itemEditClone = _.cloneDeep(itemEdit) || {};
    itemEditClone.name = recipeName;
    itemEditClone.description = recipeDesc;
    itemEditClone.prep_hours = prepHours;
    itemEditClone.prep_minutes = prepMinutes;
    itemEditClone.cook_hours = cookHours;
    itemEditClone.cook_minutes = cookMinutes;
    itemEditClone.servings = servings;
    setItemEditState(itemEditClone);
  }

  useEffect(() => {
    if (!_.isEmpty(itemEdit)) {
      setRecipeName(itemEdit?.name);
      setRecipeDesc(itemEdit?.description);
      setPrepHours(itemEdit?.prep_hours)
      setPrepMinutes(itemEdit?.prep_minutes)
      setCookHours(itemEdit?.cook_hours)
      setCookMinutes(itemEdit?.cook_minutes)
      setServings(itemEdit?.servings)
    }
  }, []);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.boxForm}>
          <div className={classes.leftForm}>
            <LabelInput
              name="recipeName"
              value={recipeName}
              label="Name"
              onChange={onChangeBlurNameRecipe}
              ref={register({ required: true, validate: (value: any) => value.trim() !== '' })}
              errors={errorRecipeName}
              maxLength={50}
            />
            <LabelTextArea
              name="recipeDesc"
              value={recipeDesc}
              label="Description"
              onChange={onChangeBlurRecipeDesc}
              ref={register({ required: true, validate: (value: any) => value.trim() !== '' })}
              errors={errorRecipeDesc}
              maxLength={255}
            />
          </div>
          <div className={classes.rightForm}>
            <CustomDropDown
              data={HOURS}
              name="prepHours"
              label="Prep Time"
              placeholder="Hours"
              onChangeCategory={onSelectPrepHours}
              value={prepHours}
              customClass={classes.dropdown}
              ref={register({ required: true })}
              errors={errors?.prepHours}
            />
            <CustomDropDown
              data={MINUTES}
              name="prepMinutes"
              placeholder="Minutes"
              onChangeCategory={onSelectPrepMinutes}
              value={String(prepMinutes)}
              customClass={classes.dropdown}
              ref={register({ required: true })}
              errors={errors?.prepMinutes}
            />
            <CustomDropDown
              data={HOURS}
              name="cookHours"
              label="Cook time"
              placeholder="Hours"
              onChangeCategory={onSelectCookHours}
              value={String(cookHours)}
              customClass={classes.dropdown}
              ref={register({ required: true })}
              errors={errors?.cookHours}
            />
            <CustomDropDown
              data={MINUTES}
              name="cookMinutes"
              placeholder="Minutes"
              onChangeCategory={onSelectCookMinutes}
              value={String(cookMinutes)}
              customClass={classes.dropdown}
              ref={register({ required: true })}
              errors={errors?.cookMinutes}
            />
            <CustomDropDown
              data={SERVINGS}
              name="servings"
              label="Servings"
              placeholder="2"
              onChangeCategory={onSelectServings}
              value={String(servings)}
              customClass={classes.dropdown}
              ref={register({ required: true })}
              errors={errors?.servings}
            />
          </div>
        </div>
      </div>
      <div className={classes.footerModal}>
        <button className={classes.cancelButton} onClick={onHandleCloseModal}>
          Cancel
        </button>
        <button className={classes.nextButton} onClick={onNextStep1}>
          Next
          <div className={classes.nextButtonIconContainer}>
            <img src={nextArrowIcon} alt="Next Button Icon" />
          </div>
        </button>
      </div>
    </>
  );
};

export default Step1;
